import { queueOvertimeApi } from "./queue-overtime.api";

export const { useGetQueueOvertimeOpenByCompanyQuery, useGetQueueOvertimeHistoryByCompanyQuery } = queueOvertimeApi;
